export class user {
  id: number;
  user_upn: string;
  user_email: string;
  user_role: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  lastUpdatedBy: string;
  is_active: number;
}


//this is the old code


// export class user {
//   id: number;
//   user_email: string;
//   email_address: string;
//   user_role: string;
//   createdAt: string;
//   updatedAt: string;
//   is_active:number

// }
